export const technologyData = [
  {
    title: "Web3 Technology Stack",
    content: [
      {
        type: "heading",
        text: "The Foundation of Decentralized Applications"
      },
      {
        type: "paragraph",
        text: "The Web3 technology stack represents a fundamental shift from traditional web development, incorporating blockchain, decentralized storage, and peer-to-peer networking to create truly decentralized applications."
      },
      {
        type: "list",
        items: [
          "Protocol Layer: Blockchain networks like Ethereum, Solana, Polygon",
          "Infrastructure Layer: IPFS, Filecoin, Arweave for decentralized storage",
          "Development Layer: Smart contracts, oracles, indexing protocols",
          "Application Layer: DApps, wallets, and user interfaces"
        ]
      }
    ]
  },
  {
    title: "Smart Contracts and Oracles",
    content: [
      {
        type: "heading",
        text: "Programmable Blockchain Logic"
      },
      {
        type: "paragraph",
        text: "Smart contracts are self-executing contracts with terms directly written into code. Oracles bridge the gap between blockchain and real-world data."
      },
      {
        type: "list",
        items: [
          "Ethereum Virtual Machine (EVM) compatibility",
          "Solidity and Vyper programming languages",
          "Chainlink and Band Protocol oracles",
          "Automated execution and trustless operations"
        ]
      }
    ]
  },
  {
    title: "Development Tools and Frameworks",
    content: [
      {
        type: "heading",
        text: "Building Web3 Applications"
      },
      {
        type: "paragraph",
        text: "Modern Web3 development requires specialized tools and frameworks designed for blockchain integration."
      },
      {
        type: "list",
        items: [
          "Hardhat and Truffle for smart contract development",
          "MetaMask and WalletConnect for wallet integration",
          "Web3.js and Ethers.js libraries",
          "React, Vue, and Angular with Web3 components",
          "IPFS and Pinata for decentralized file storage"
        ]
      }
    ]
  },
  {
    title: "Consensus Mechanisms",
    content: [
      {
        type: "heading",
        text: "Securing Decentralized Networks"
      },
      {
        type: "paragraph",
        text: "Consensus mechanisms ensure network agreement and security in blockchain systems."
      },
      {
        type: "list",
        items: [
          "Proof of Work (PoW): Bitcoin's energy-intensive but secure approach",
          "Proof of Stake (PoS): Ethereum 2.0's energy-efficient alternative",
          "Delegated Proof of Stake (DPoS): Fast transaction processing",
          "Proof of History (PoH): Solana's innovative timestamping method"
        ]
      }
    ]
  },
  {
    title: "Emerging Technologies",
    content: [
      {
        type: "heading",
        text: "The Future of Web3 Technology"
      },
      {
        type: "paragraph",
        text: "Cutting-edge technologies are pushing the boundaries of what's possible in Web3."
      },
      {
        type: "list",
        items: [
          "Zero-Knowledge Proofs: Privacy-preserving verification",
          "Layer 2 Solutions: Scaling blockchain networks",
          "Cross-chain Bridges: Interoperability between blockchains",
          "Quantum-resistant Cryptography: Future-proofing security",
          "AI and Machine Learning integration with blockchain"
        ]
      }
    ]
  }
];
